import { IncomingInvoiceTimelineDescriptionItem, IncomingInvoiceTimelineItem } from "./../../actionLog/models/index";
import dayjs, { Dayjs } from "dayjs";
import { t } from "@/plugins/i18n";

export default class FlowHistory implements IncomingInvoiceTimelineItem {
  orderId = 0;
  orderNo = "";
  storeIn = 0;
  orderDate: Date = new Date();
  offerDate: Date = new Date();
  orderer = "";
  deliveryDate: Date = new Date();
  certifNo = "";
  storeInUser = "";
  invoiceDate: Date = new Date();
  regDate: Date = new Date();

  constructor(params?: Partial<FlowHistory>) {
    const data = { ...params };
    Object.assign(this, data);
  }

  /*
   * IncomingInvoiceTimelineItem implementation for IncomingInvoiceTimeline.vue
   */
  get timestamp(): Dayjs {
    return dayjs(this.regDate);
  }

  get title(): string {
    return t("InvoiceFlow_Beszerzes");
  }

  get subtitle(): string {
    return ``;
  }

  get description(): string | IncomingInvoiceTimelineDescriptionItem[] | undefined {
    return [
      { label: t("InvoiceFlow_Rendeles"), value: `${dayjs(this.orderDate).format("YYYY. MM. DD.")}, ${this.orderer}` },
      { label: t("InvoiceFlow_MegrendelesSzam"), value: this.orderNo },
      { label: t("InvoiceFlow_Betarolas"), value: `${dayjs(this.deliveryDate).format("YYYY. MM. DD.")}, ${this.storeInUser}` },
      { label: t("InvoiceFlow_SzallitolevelSzam"), value: this.certifNo },
      { label: t("InvoiceFlow_SzamlaKelte"), value: `${dayjs(this.invoiceDate).format("YYYY. MM. DD.")}` },
    ];
  }

  get icon(): string {
    return `fa-cube`;
  }

  get color(): string {
    return `lighten-3 blue`;
  }
}
